import styled from "styled-components";
import { Card } from "antd";

export const Wrapper = styled(Card)`
  /* margin-top: 50px;
  margin-right: 10%;
  margin-left: 10%;
  margin-bottom: 20%;
  padding: 5% 8%;

  background: #ffffff;
  border: 1px solid #cecece;
  border-radius: 5px; */
  .scollTable {
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    width: 100%;
    border: 1px solid #cecece;
  }

  .scollTable .ant-table-cell {
    font-size: 0.7rem !important;
    width: 120px;
    padding: 10px 10px;
  }

  @media (max-width: 600px) {
    .scollTable .ant-table-cell {
      font-size: 0.8rem;
      width: 150px;
    }
  }
`;
